'use strict';

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    banner: {
      position: 'relative',
      backgroundColor: theme.banner.mainBgColor,
      borderRadius: theme.banner.borderRadius,
      wordBreak: 'break-all',
      color: theme.banner.textColor,
      '&:before': {
        content: '""',
        position: 'absolute',
        width: 4,
        top: 0,
        left: 0,
        bottom: 0,
        borderRadius: theme.banner.borderRadius,
        backgroundColor: theme.banner.mainLineBgColor
      },
      '& a': {
        color: theme.banner.linkColor,
        textDecoration: 'none',
        '&:hover': {
          color: theme.banner.linkHoverColor
        }
      },
      '& b': {
        fontWeight: theme.banner.fontWeight.semibold
      },
      '&.error': {
        backgroundColor: theme.banner.errorBgColor,
        '&:before': {
          backgroundColor: theme.banner.errorLineBgColor
        }
      },
      '&.hidden': {
        display: 'none'
      }
    },
    small: {
      padding: '4px 12px',
      fontSize: theme.banner.fontSize.small
    },
    medium: {
      padding: '8px 16px',
      fontSize: theme.banner.fontSize.medium
    }
  };
};